<template>
  <page-header>
    <h2>Реестр вакансий</h2>
    <template #actions>
      <div class='d-flex align-items-baseline actions'>
        <button-component @click='editCard(0)'>Создать</button-component>
        <!--          <button-component class="ml-2" @click="importRegistry">Импорт из ПК Катарсис</button-component>-->
        <button-component kind="tertiary" :class="{filtered: isFiltered}" @click="modals.filter = !modals.filter">
          <template #prepend>
            <icon-component class="mr-2" name="filter"/>
          </template>
          Фильтр
        </button-component>
      </div>
    </template>
  </page-header>

  <section class="content">
    <template v-if="page.items?.length">
      <div class="table-inner">
        <table class="table-custom">
          <thead>
          <tr>
            <th style="width:50px"></th>
            <th style="width:5%" class="text-center">№</th>
            <th>Наименование организации</th>
            <th>ИНН</th>
            <th>Кол-во вакансий для ЛРАС</th>
            <th>Статус</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in page.items" :key="item.id" @dblclick="editCard(item.id)">
            <td>
              <menu-component class="actions" :actions="actions(item)"/>
            </td>
            <td>{{ page.firstItemNumber + index }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.inn }}</td>
            <td>{{ item.forPatientCount }}</td>
            <td>{{ item.status }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-if="page.pagesTotal > 1">
        <Pagination :page-count="page.pagesTotal" :current-page="page.pageNumber" @change="onPageChange($event)"/>
      </div>
      <div>
        <PageCounter :isFiltered="isFiltered" :totalCount="totalCount" :filteredCount="page.itemsTotal" />
      </div>
    </template>
    <template v-else>
      <EmptyListMessage/>
    </template>
    <section class="modals">
      <transition name="filter">
        <div class="filter" v-if="modals.filter">
          <VacancyFilters v-bind:filters="filters" v-on:apply="onFiltersApply($event)"
                          v-on:reset="onFiltersReset($event)"/>
        </div>
      </transition>
    </section>
  </section>


</template>
<script>
import API from '../api/vacancy';
import PageHeader from "@/common/components/page/PageHeader";
import EmptyListMessage from "@/common/components/EmptyListMessage";
import MenuComponent from "@/common/ui/components/page/MenuComponent";
import VacancyFilters from './VacancyFilters.vue';
import filtermanager from "@/common/mixins/filtermanager";
import ButtonComponent from '@/common/ui/ButtonComponent';
import IconComponent from '@/common/ui/IconComponent';
import Constants from '@/common/constants';
import security from "@/common/mixins/security";
import PageCounter from "@/common/components/PageCounter";

export default {
  name: "VacancyList",
  components: {
    PageHeader,
    EmptyListMessage,
    MenuComponent,
    VacancyFilters,
    ButtonComponent,
    IconComponent,
    PageCounter
  },
  mixins: [filtermanager, security],
  data() {
    return {
      request: {},
      filters: {
        name: '',
        inn: '',
        acceptsPatients: null,
        employerStatusId: 0
      },
      page: {},
      modals: {
        filter: false
      },
      isFiltered: false,
      canViewVacancy: false,
      canEditVacancy: false,
      totalCount: 0
    }
  },
  created() {
    this.getAccessMatrix([Constants.VacancyView, Constants.VacancyEdit])
        .then((response) => {
          this.canViewVacancy = response.data[Constants.VacancyView];
          this.canEditVacancy = response.data[Constants.VacancyEdit];
        });
    this.getTotalCount();
    this.loadPage();
  },
  methods: {
    getTotalCount() {
      const self = this;
      API.search({ pageNumber: 1, pageSize: 1}).then(function (response) {
        self.totalCount = response.data.itemsTotal;
      });
    },
    viewCard(id) {
      this.$router.push({name: 'cardVacancy', params: {id: id, action: 'view'}})
    },
    editCard(id) {
      if (this.canEditVacancy) {
        this.$router.push({name: 'cardVacancy', params: {id: id, action: 'edit'}})
      } else {
        this.viewCard(id);
      }
    },
    deleteCard(id) {
      Constants.alert.fire(Constants.confirmOptions.delete).then((res) => {
        if (res.isConfirmed) {
          API.delete(id).then((response) => {
            Constants.alert.fire('Удаление', response.data.message, response.data.success ? 'success' : 'error')
            if (response.data.success) {
              this.getTotalCount();
              this.loadPage();
            }
          })
        }
      })
    },
    actions(item) {
      let result = [];
      if (this.canViewVacancy) {
        result.push({
          title: 'Просмотр',
          icon: 'eye',
          click: () => this.viewCard(item.id)
        });
      }
      if (this.canEditVacancy) {
        result = result.concat([
          {
            title: 'Редактировать',
            icon: 'pen',
            click: () => this.editCard(item.id)
          },
          {
            title: 'Удалить',
            icon: 'trash',
            click: () => {
              this.deleteCard(item.id)
            }
          },
        ]);
      }
      return result;
    },
    onPageChange(pageNumber) {
      this.request.pageNumber = pageNumber;
      this.loadPage()
    },
    loadPage() {
      const filter = this.loadFilter();
      if (filter) {
        this.filters = filter;
        this.isFiltered = true;
      }
      var params = Object.assign(this.filters, this.request);
      API.search(params).then((response) => {
        this.page = response.data;
      });
    },
    onFiltersApply(filters) {
      this.filters = filters;
      this.request.pageNumber = 1;
      this.modals.filter = false;
      this.saveFilter(this.filters);
      this.isFiltered = true;
      this.loadPage();
    },
    onFiltersReset(filters) {
      this.filters = filters || {};
      this.request.pageNumber = 1;
      this.modals.filter = false;
      this.removeFilter();
      this.isFiltered = false;
      this.loadPage();
    },
    importRegistry() {

    }
  }
}
</script>
<style lang="scss" scoped>
@import '/src/assets/theme/default/colors.scss';

.content {
  padding: 32px;
  position: relative;
  overflow-y: visible;

  .filter {
    position: absolute;
    width: 350px;
    height: auto;
    top: 0;
    right: 0;
    overflow: hidden;
    background-color: transparent;
    opacity: 1;
    transition: opacity .2s;
  }

  .filter-enter, .filter-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }
}
</style>